// extracted by mini-css-extract-plugin
module.exports = {"screenReaderContainer":"index_screenReaderContainer__2npZJ","content":"index_content__2DthO","closeIcon":"index_closeIcon__3sp9g","typeText":"index_typeText__bYPHG"};